import '@contentful/live-preview/style.css';
import React from 'react';
import { ApolloProvider } from '@apollo/client/react';
import { ContentfulLivePreviewProvider } from '@contentful/live-preview/react';
import { Client } from './src/apollo';

import { StateProvider } from './src/layouts/base/Context/Store';
import { checkLivePreviewSetup } from './src/utils';

const wrapPageElement = ({ element }) => {
  const response = checkLivePreviewSetup();
  return (
    <ApolloProvider client={Client}>
      <StateProvider>
        <ContentfulLivePreviewProvider
          enableInspectorMode={response.isEnabled}
          enableLiveUpdates={response.isEnabled}
          debugMode={response.isEnabled}
          locale={response.locale}
        >
          {element}
        </ContentfulLivePreviewProvider>
      </StateProvider>
    </ApolloProvider>
  );
};

export default wrapPageElement;
